import { Container, decorate, injectable, inject } from 'inversify';
import 'reflect-metadata';

import client from '@/core/client';
import {
  AuthService,
  DeployService,
  MetadataService,
  SalesforceService,
  XmlService,
} from '@/services';

import Tokens from './tokens';

decorate(injectable(), AuthService);
decorate(injectable(), DeployService);
decorate(injectable(), MetadataService);
decorate(injectable(), SalesforceService);
decorate(injectable(), XmlService);

decorate(inject(Tokens.Client), AuthService, 0);
decorate(inject(Tokens.Client), MetadataService, 0);
decorate(inject(Tokens.Client), DeployService, 0);
decorate(inject(Tokens.Client), SalesforceService, 0);
decorate(inject(Tokens.Client), XmlService, 0);

const container = new Container();

container.bind(Tokens.AuthService).to(AuthService);
container.bind(Tokens.DeployService).to(DeployService);
container.bind(Tokens.MetadataService).to(MetadataService);
container.bind(Tokens.SalesforceService).to(SalesforceService);
container.bind(Tokens.XmlService).to(XmlService);

container.bind(Tokens.Client).toConstantValue(client);

export default container;
